import css from "./lastOrderFragment.module.css";
import { Heading, IconArrowBigRight, IconLink, Text } from "@idg-web-platform/pulse";
import { OrderSummary, renderSummary } from "./orderSummary.tsx";

LastOrderFragment.tagName = "control-orders-last";

export interface LastOrderFragmentProps {
  order: OrderSummary;
}

export function LastOrderFragment({ lastOrder }: { lastOrder?: LastOrderFragmentProps }) {
  return (
    <>
      <div className={css.sectionHeadline}>
        <Heading text="Meine letzte Bestellung" removeMargin={true} element={"h2"} sizeStep={2} />
        <IconLink
          text="Bestellübersicht"
          href="/c/orders"
          iconComponent={<IconArrowBigRight />}
          iconPosition="right"
        />
      </div>
      {lastOrder ? (
        renderSummary(lastOrder.order)
      ) : (
        <Text sizeStep={0}>Du hast noch keine Bestellung auf intersport.de vorgenommen.</Text>
      )}
    </>
  );
}
